  <!-- 加油记录 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore">
      <template slot="time1">
        <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time"></multitime>
      </template>
    </input-plug>

    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" ref="mytable" @rowCallback="rowCallback" @selectChange="handleSelectionChange" @jumpPage="goYdDetails" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />

    <!-- 新增弹窗 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <dia-form :diaFormConfig="diaFormConfig" ref="diaform" :rules="formRules" :baseModel="baseModel" :Reset="isShowDialog" @changeCallback="changeCallback" />
    </my-dialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true">
        <template slot="time1">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time"></multitime>
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
        <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1,exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "加油记录", //导出时默认文件名
        apiName: "/admin/v3/tms/car/oil/record/getOilRecordList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新增",
          method: "addClick",
          permissVal: "admin:oil_record:addOilRecord",
        },
        {
          name: "修改",
          method: "modifyClick",
          permissVal: "admin:oil_record:udpateOilRecord",
        },
        {
          name: "删除",
          method: "delete",
          permissVal: "admin:oil_record:delOilRecord",
        },
        {
          name: "审核",
          method: "examine",
          permissVal: "admin:oil_record:examineOilRecord",
        },
        {
          name: "返审核",
          method: "deApprove",
          permissVal: "admin:oil_record:reExamineOilRecord",
        },

        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "导出",
          method: "ExportData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "input",
          label: "卡号",
          field: "oilCardNumber",
          placeholder: "请输入",
        },

        {
          type: "input",
          label: "加油人",
          field: "oiler",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "状态",
          field: "approveStatus",
          placeholder: "请选择",
          selectOptions: [{ label: "全部", val: "1" }],
        },
      ],

      queryData: {
        approveStatus: null,
        oilCardNumber: null,
        oiler: null,
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "加油时间",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      className: "", //  导出需要
      pageGroupName: "GasupRecord", //  页面标识
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          width: 220,
          Buttons: [
            {
              method: "modifyClick",
              methodName: "修改",
              permissVal: "admin:oil_record:udpateOilRecord",
            },
            {
              method: "delete",
              methodName: "删除",
              permissVal: "admin:oil_record:delOilRecord",
            },
            {
              method: "examine",
              methodName: "审核",
              permissVal: "admin:oil_record:examineOilRecord",
            },
            {
              method: "deApprove",
              methodName: "返审核",
              permissVal: "admin:oil_record:reExamineOilRecord",
            },
          ],
        },
        {
          name: "加油时间",
          field: "operationTime",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车牌号码",
          field: "carNumber",
          sort: 4,
          isShow: true,
          isSort: true,
        },
        {
          name: "油卡号码",
          field: "oilCardNumber",
          sort: 5,
          isShow: true,
          isSort: true,
        },
        {
          name: "单价",
          field: "unitPrice",
          sort: 5,
          isShow: true,
          isSort: true,
        },
        {
          name: "油量",
          field: "oilQuantity",
          sort: 6,
          isShow: true,
          isSort: true,
        },
        {
          name: "金额",
          field: "amount",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        // {
        //   name: "数量",
        //   field: "packageStatusShow",
        //   width: "200",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
        {
          name: "加油地址",
          field: "oilStationAddress",
          sort: 18,
          isShow: true,
        },
        {
          name: "加油人",
          field: "oiler",
          sort: 19,
          isShow: true,
        },
        {
          name: "创建人",
          field: "createUserName",
          sort: 19,
          isShow: true,
        },
        {
          name: "状态",
          field: "approveStatusShow",
          sort: 19,
          isShow: true,
        },
        {
          name: "备注",
          field: "remarks",
          sort: 19,
          isShow: true,
        },
      ],
      sortName: "加油记录", //  排序名
      //   车辆弹窗
      diaWidth: "60%",
      dialogTitle: "加油记录",
      isShowDialog: false,
      diaFormConfig: [
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "加油时间",
              itemType: "datetime",
              field: "operationTime",
              placeholder: "请选择",
            },
            {
              span: 8,
              title: "车牌号",
              itemType: "select",
              field: "carNumber",
              placeholder: "请选择",
              setLabel: "carNumber",
              setValue: "carNumber",
              selectChange: "carNumberChange",
              options: [],
            },
            {
              span: 8,
              title: "油卡号",
              itemType: "select",
              field: "oilCardNumber",
              setLabel: "numberLabel",
              setValue: "oilCardNumber",
              placeholder: "请选择",
              options: [],
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "单价",
              itemType: "input",
              field: "unitPrice",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "油量(L)",
              itemType: "input",
              field: "oilQuantity",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "金额",
              itemType: "input_icon",
              clickName: "countMoney",
              field: "amount",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "加油人",
              itemType: "input",
              field: "oiler",
              placeholder: "请输入",
            },
            {
              span: 16,
              title: "加油地址",
              itemType: "input",
              field: "oilStationAddress",
              placeholder: "请输入",
            },
          ],
        },

        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "remarks",
              placeholder: "请输入",
            },
          ],
        },
      ],
      formRules: {
        carNumber: [{ required: true, message: "请输入", trigger: "blur" }],
        oilCardNumber: [
          { required: true, message: "请输入有效油卡号", trigger: "blur" },
        ],
        operationTime: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
      baseModel: {
        amount: null,
        oilQuantity: null,
        unitPrice: null,
      },
      defaultBaseModel: {
        carNumber: null,
        oilCardNumber: null,
        operationTime: null,
        amount: null,
        oilQuantity: null,
        oilStationAddress: null,
        oiler: null,
        remarks: null,
        unitPrice: null,
      },
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.GetData();
    this.GetCarDownList();
  },
  methods: {
    // 获取加油记录列表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.queryData.startOilTime = `${this.startTime_a} 00:00:00`;
      this.queryData.endOilTime = `${this.endTime_a} 23:59:59`;
      this.$API.OilRecordList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result?.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---加油记录列表`);
        }
      });
    },

    // 获取弹窗车牌
    GetCarDownList() {
      this.$API.CarDownList().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          this.diaFormConfig[0].formItem[1].options = result;
        }
      });
    },

    // 获取油卡
    carNumberChange(val) {
      this.$API.OilCardDownList({ carNumber: val }).then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          for (let i in result) {
            let MainCard = result[i].isMainCard == 1 ? "（主）" : "（子）";
            result[i].numberLabel = result[i].oilCardNumber + MainCard;
          }
          this.diaFormConfig[0].formItem[2].options = result;
        }
      });
    },

    // 监听封装表单的select
    changeCallback(val, name) {
      this.diaFormConfig[0].formItem[2].options = [];
      this[name](val);
    },

    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },
    // 计算金额
    countMoney() {
      // 金额 = 单价 * 油价
      let unitPrice = this.baseModel.unitPrice * 1;
      let oilQuantity = this.baseModel.oilQuantity * 1;
      if (unitPrice && oilQuantity) {
        this.baseModel.amount = unitPrice * oilQuantity;
      } else {
        this.baseModel.amount = "";
        this.$message.warning("单价和油价不能为空！");
      }
    },
    // 表格设置
    SetTable() {
      this.$TOOLS.myModel(this);
    },
    // 导出
    ExportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
    // 新增
    addClick() {
      this.isShowDialog = true;
    },
    // 修改
    modifyClick(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.isShowDialog = true;
        this.baseModel = this.selectTableData[0];
      }
    },
    // 删除
    delete(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              recordIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.recordIds.push(val.recordId);
            });
            this.$API.delOilRecord(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.recordIds.length > 2) {
                    delReq.recordIds.map(function (v, i) {
                      num = arr.findIndex((element) => element.recordId == v);
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) => element.recordId == delReq.recordIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 审核
    examine(data, t) {
      if (data) this.selectTableData = [data];
      let msg = "确认要审核通过所选数据?";
      if (t) msg = t;
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm(msg, "提示:")
          .then((res) => {
            let params = {
              recordIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              params.recordIds.push(val.recordId);
            });

            if (t) {
              // 翻审核接口
              this.$API.reExamineOilRecord(params).then((r) => {
                if (r.data.status === "success") {
                  this.GetData();
                  this.$message.success(r.data.message);
                }
              });
            } else {
              // 审核接口
              this.$API.examineOilRecord(params).then((e) => {
                if (e.data.status === "success") {
                  this.GetData();
                  this.$message.success(e.data.message);
                }
              });
            }
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 返审核
    deApprove(data) {
      this.examine(data, "确认要把所选数据返审核？");
    },

    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.startTime_a = "";
      this.endTime_a = "";
      this.GetData();
    },

    // 时间查询框选择时间时的事件
    queryBtn_time(t1, t2) {
      this.startTime_a = t1;
      this.endTime_a = t2;
      if (t1 && t2) {
        this.GetData();
      }
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs["diaform"].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          for (let key in this.defaultBaseModel) {
            if (this.baseModel[key]) {
              eval("param." + key + "='" + this.baseModel[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          if (this.baseModel.recordId) param.recordId = this.baseModel.recordId;
          if (param.recordId && param.recordId !== null) {
            // 修改接口
            this.$API.udpateOilRecord(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          } else {
            // 新增接口
            this.$API.addOilRecord(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          }
          this.isShowDialog = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.baseModel = {};
      this.selectTableData.length = 0;
      this.$refs.mytable.$refs.tables.clearSelection();
      this.isShowDialog = false;
    },

    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.handleCloseDia();
    },
  },
};
</script>
        <style scoped lang="less">
</style>
        